import axios from "axios";
import { toast } from "react-toastify";
import { API, Endpoints } from "./Constants";
import { getAuthString, removeEmptyValues, reverseObject } from "./Utilities";



export const ServerAPI = {
  APIMethod: {
    GET: "GET",
    POST: "POST",
    PUT: "PUT",
    DELETE: "DELETE"
  },

  applicationList: async (filters) => {
    let data = {};
    data = filters;
    return ServerAPI.executeAPI(API.EndPoint.applicationList, ServerAPI.APIMethod.POST, true, data);
  },
  applicationInfo: async () => {
    return ServerAPI.executeAPI(API.EndPoint.applicationInfo + localStorage.getItem('applicationId'), ServerAPI.APIMethod.GET, true);
  },
  downloadDocuments: async (type) => {
    return ServerAPI.executeAPI(API.EndPoint.downloadDocuments + localStorage.getItem('applicationId') + "/" + type, ServerAPI.APIMethod.GET, true);
  },
  fileUpload: async (file) => {
    const formData = new FormData();
    formData.append('file', file);
    formData.append('module', 'agent');
    return ServerAPI.executeAPI(API.EndPoint.uploadDocument, ServerAPI.APIMethod.POST, true, formData, null, false, false, true);
  },
  updateProductStatus: async (dataValues) => {
    let data = {};
    data = dataValues;
    return ServerAPI.executeAPI(API.EndPoint.updateProductStatus, ServerAPI.APIMethod.POST, true, data);
  },
  updateGuarantorStatus: async (dataValues) => {
    let data = {};
    data = dataValues;
    return ServerAPI.executeAPI(API.EndPoint.updateGuarantorStatus, ServerAPI.APIMethod.POST, true, data);
  },
  previewLoanApplicantion: async (productId) => {
      return ServerAPI.executeAPI(API.EndPoint.previewApplication + "/" + localStorage.getItem('applicationId') + "/" + productId, ServerAPI.APIMethod.GET, false);
  },
  DownloadFile: async (filepath) => {
    let data = {};
    data['filepath'] = filepath;
    return ServerAPI.executeAPI(API.EndPoint.downloadFile, ServerAPI.APIMethod.POST, false, data);
  },
  MakeAvailable: async (id) => {
    return ServerAPI.executeAPI(API.EndPoint.makeAvailable+"/"+id, ServerAPI.APIMethod.DELETE, true, null);
  },

  executeAPI: async (
    endpoint,
    method,
    authRequired,
    data,
    params,
    suppressError,
    returnError,
    fileUpload
  ) => {
    let headers = {};

    if (authRequired) {
      const persistAuthString = await getAuthString();
      if (persistAuthString) {
        headers["Authorization"] = `Bearer ${persistAuthString}`
      }
    }

    if ((method === "POST" || method === "PUT") && !fileUpload) {
      headers["Content-Type"] = "application/json";
    } else if ((method === "POST" || method === "PUT") && fileUpload) {
      headers["Content-Type"] = "multipart/form-data";
    }


    try {
      const response = await axios({
        method: method,
        url: API.BaseUrl + endpoint,
        data: !fileUpload ? JSON.stringify(data) : data,
        headers: headers,
        params: params,
      });
      return response.data;
    } catch (error) {
      if (
        axios.isAxiosError(error) &&
        error.response &&
        !suppressError &&
        !returnError
      ) {
        const errorData = error.response.data;
        if (errorData.errors && errorData.errors.length > 0) {
          if (errorData.errors) {
            toast.error(errorData.errors);
          } else {
            toast.error(errorData.errors);
          }
        } else {
          // toast.error("Error Occurred in the Request!");
        }
      }

      if (axios.isAxiosError(error) && error.response && returnError) {
        const errorData = error.response.data;
        if (errorData.errors && errorData.errors.length > 0) {
          if (errorData.errors) {
            return errorData.errors;
          }
        } else {
          // toast.error("Error Occurred in the Request!");
        }
      }
    }
  }
}
